<template>
  <div id="app">
    <!-- 头部表单 -->
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-select
          clearable
          size="small"
          @change="stateChange"
          v-model="stateId"
          placeholder="资源类型"
        >
          <el-option
            v-for="item in stateList"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          clearable
          size="small"
          @change="subjectChange"
          v-model="subjectId"
          placeholder="学科"
        >
          <el-option
            v-for="item in subjectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          size="small"
          v-model="name"
          placeholder="请输入资源名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="resList" size="small">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="setQuality('1')" type="primary" size="small"
          >设置优质资源</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button @click="setQuality('2')" type="primary" size="small"
          >取消优质资源</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 表格区域 -->
    <el-table
      border
      ref="multipleTable"
      :data="resDataList"
      :row-style="{ height: '48px' }"
      :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      stripe
      style="width: 100%; margin-bottom: 20px"
      @select="handleSelectionChange"
      @select-all="handleSelectionAll"
    >
      <el-table-column align="center" type="selection" width="55">
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        align="center"
        prop="resTitle"
        label="资源名称"
        width="240"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="subjectName"
        label="学科"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="resTypeName"
        label="资源类型"
      ></el-table-column>
      <el-table-column align="center" label="年级">
        <template slot-scope="scope">
          {{ gradeDataDeal(scope.row.bookName) }}
          <!-- {{scope.row.bookName.slice(-5)}} -->
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        width="155"
        prop="schoolName"
        label="学校"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="userName"
        label="作者"
      ></el-table-column>
      <el-table-column align="center" prop="" label="资源状态">
        <div slot-scope="scope">
          <span>{{ stateDataDeal(scope.row.resStatus) }}</span>
        </div>
      </el-table-column>
      <el-table-column align="center" prop="" label="置顶">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.resSort"
            active-color="#13ce66"
            @change="setTop(scope.row)"
            inactive-color="#E9E9E9"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        width="165"
        prop="createTime"
        label="上传时间"
      ></el-table-column>
      <el-table-column align="center" prop="" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="preview(scope.row.resId)"
            >预览</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="currentChange"
      :total="totalCount"
    ></el-pagination>
  </div>
</template>
<script>
import * as homeApi from "@/api/home";
import { ERR_OK } from "@/api/index";
export default {
  data() {
    return {
      resDataList: [],
      curPage: 1,
      pageSize: 10,
      totalCount: 0,
      groupId: localStorage.getItem("groupId"),
      stateList: [],
      stateId: "",
      subjectId: "",
      subjectList: [],
      name: "",
      resIds: [],
      resIdA: [],
    };
  },
  created() {
    this.dictCode();
    this.getSubjectList();
  },
  methods: {
    // 获取资源列表
    resList() {
      let params = {
        curPage: this.curPage,
        pageSize: this.pageSize,
        groupId: this.groupId,
        resRange: 1,
      };
      if (this.stateId !== "") {
        params.resStatus = this.stateId;
      }
      if (this.subjectId !== "") {
        params.subjectId = this.subjectId;
      }
       if (this.name !== "") {
        params.resTitle = this.name;
      }
      homeApi.resList(params).then((res) => {
        if (res.data.data.dataList.length !== 0) {
          res.data.data.dataList.forEach((item) => {
            if (item.resSort == 1) {
              item.resSort = true;
            } else {
              item.resSort = false;
            }
          });
        }
        this.resDataList = res.data.data.dataList;
        this.totalCount = res.data.data.totalCount;
        if (this.resIds.length !== 0) {
          this.resIds.forEach((item) => {
            this.resDataList.forEach((items) => {
              if (items.resId == item) {
                setTimeout(() => {
                  this.$refs.multipleTable.toggleRowSelection(items);
                });
              }
            });
          });
        }
      });
    },
    // 字典获取  资源状态
    dictCode() {
      homeApi
        .dictCode({
          code: "res_status",
        })
        .then((res) => {
          this.stateList = res.data.data;
          this.resList();
        });
    },
    // 数据处理
    stateDataDeal(id) {
      let name = "";
      this.stateList.forEach((item) => {
        if (item.code == id) {
          name = item.name;
        }
      });
      return name;
    },
    // 年级数据处理
    gradeDataDeal(str) {
      return str.slice(str.lastIndexOf("-") + 1);
    },
    // 页码变化
    currentChange(e) {
      this.curPage = e;
      this.resList();
    },
    // 预览
    preview(id) {
      let url =
        "http://bk.welaiedu.cn/#/prepare_pdf?id=" +
        id +
        "&token=" +
        localStorage.getItem("token");
      window.open(url, "_blank");
    },
    // 资源单选
    handleSelectionChange(val, row) {
      let idx = this.resIds.indexOf(row.resId);
      if (idx == -1) {
        this.resIdA.push(row.resStatus);
        this.resIds.push(row.resId);
      } else {
        this.resIdA.splice(idx, 1);
        this.resIds.splice(idx, 1);
      }
    },
    // 资源全选
    handleSelectionAll(val) {
      if (val.length == 0) {
        this.resDataList.forEach((item, index) => {
          let idx = this.resIds.indexOf(item.resId);
          if (idx !== -1) {
            this.resIdA.splice(idx, 1);
            this.resIds.splice(idx, 1);
          }
        });
      } else {
        val.forEach((item) => {
          let idx = this.resIds.indexOf(item.resId);
          if (idx == -1) {
            this.resIdA.push(item.resStatus);
            this.resIds.push(item.resId);
          }
        });
      }
    },
    // 获取学科列表
    getSubjectList() {
      homeApi.getSubjectList({ stage: -1 }).then((res) => {
        this.subjectList = res.data.data;
      });
    },
    // 资源变化
    stateChange() {
      this.resList();
    },
    // 学科变化
    subjectChange() {
      this.resList();
    },
    // 资源设置
    setQuality(flag) {
      if (this.resIds.length == 0) {
        this.$message.error("请选择资源");
        return false;
      }
      let params = {};
      let flags = true;
      if (flag == 1) {
        this.resIdA.forEach((item) => {
          // if (item == 20) {
          //   flags = false;
          // }
        });
        params = {
          resIds: this.resIds,
          resStatus: 20,
        };
      } else {
        this.resIdA.forEach((item) => {
          if (item !== 20) {
            flags = false;
          }
        });
        params = {
          resIds: this.resIds,
          resStatus: 15,
        };
      }
      if (!flags) {
        this.$message.error("请先排除选中资源中优质资源选项！");
        flags = true;
        return false;
      }

      homeApi.batchReview(params).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: "设置成功",
            type: "success",
          });
          this.resIds = [];
          this.resIdA = [];
          this.resList();
        }
      });
    },
    // 置顶操作
    setTop(row) {
      let resSort = 0;
      if (row.resSort) {
        resSort = 1;
      }
      let params = {
        resId: row.resId,
        resSort: resSort,
      };
      homeApi.setTop(params).then((res) => {
        if (res.data.code == 0) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/resources/ment.vue